import { Fragment, useContext } from "react"
import { ChildItem } from "../.."
import { Delete, Update } from "./components"
import type { DataList, DataItem } from "../../../../types"
import { useToggle } from "../../../../../../../../utils"
import { dataContext } from "pages/Setup/Preference/JobPosition"
import { Checkbox, TableNumber } from "components"
import { DeleteContext } from "pages/Setup/contexts"

export function Item(props: { item: DataList, index: number, dataList: DataItem, refetch: () => void }) {
  const { isActive } = useToggle(false)
  const { currentPage, limit, size, total } = useContext(dataContext)
  const { toggleDeleteData, value } = useContext(DeleteContext)

  return (
    <Fragment>
      <tr>
        <td>{TableNumber({ dataLength: size, pageCurrent: currentPage, index: props.index, limit: limit, totalData: total })}</td>
        <td className="w-[1px]">
          <Checkbox
            value={Boolean(value.find(val => val === props.item.job_position_id))}
            onClick={() => toggleDeleteData(props.item.job_position_id)}
          />
        </td>
        <td>{props.item.divisi_name}</td>
        <td>{props.item.job_position_name}</td>

        <td>
          <div dangerouslySetInnerHTML={{ __html: props.item.description ?? "" }}></div>
        </td>

        <td>
          <div className="flex items-center justify-center">
            <Update id={props.item.job_position_id} refetch={props.refetch} toggle={() => {}} />
            <Delete id={props.item.job_position_id} refetch={props.refetch} toggle={() => {}} />
          </div>
        </td>
      </tr>
      {isActive && <ChildItem dataList={props.dataList} refetch={props.refetch} />}
    </Fragment>
  )
}